<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <p class="text-muted font-13 mb-4"></p>
            <div class="row mb-md-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions">
                    </b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2">
                    </b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                ref="orderReportTable"
                :items="ledgerReportData"
                :busy.sync="isBusy"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn">

                <template v-slot:cell(id)="row">
                  <a href="javascript: void(0);"
                     class="text-body font-weight-bold"
                  >{{row.item.id}}</a>
                </template>

                <template v-slot:cell(company)="row">
                  {{ companyColumn(row.item) }}
                </template>

                <template v-slot:cell(unitAction)="row">
                  <b-button :id="row.item.id" variant="primary"
                            type="button" class="btn btn-blue" @click="showModal(row.item)">
                    <i class="mdi mdi-eye"></i>
                  </b-button>
                </template>

              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            @input =" pageChange(currentPage);">
                    </b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="remark-modal" ref="remark" size="lg" title="Description" title-class="font-18">
      <p>{{ this.remarkDetail}}</p>
    </b-modal>
  </Layout>
</template>

<script>
  import appConfig from '@src/app.config'
  import Layout from '@layouts/main'
  import PageHeader from '@components/page-header'

  import { reportMethods } from '@state/helpers'


  /**
   * Advanced table component
   */
  export default {
    page: {
      title: 'Ledger',
      meta: [{ name: 'description', content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
      return {
        orders: [],
        title: 'Ledger',
        items: [
          {
            text: '99Gift',
            href: '/',
          },
          {
            text: 'Reports',
            href: '/',
          },
          {
            text: 'Ledger',
            active: true,
          },
        ],
        isBusy: false,
        remarkDetail: null,
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: 'id',
        sortDesc: false,
        fields: [
          { key: 'id', label: 'Id', sortable: true },
          { key: 'company', label: 'Company name', sortable: false },
          { key: 'created_at', label: 'Date', sortable: false },
          { key: 'txn_id', label: 'Txn Id', sortable: false },
          { key: 'action',  label: 'Action', sortable: false },
          { key: 'debit', label: 'Debit', sortable: true },
          { key: 'credit', label: 'Credit', sortable: true },
          { key: 'opening_balance', label: 'Opening balance', sortable: true },
          { key: 'closing_balance',  label: 'Closing balance', sortable: false },
          { key: 'unitAction',  label: 'Actions', sortable: false }
        ],
      }
    },
    computed: {
      /**
       * Total no. of records
       */
      rows() {
        return this.totalRows
      },
    },
    async mounted() {
      // Set the initial number of items
    },
    methods: {
      ...reportMethods,

      showModal(data){
        if(data){
          this.remarkDetail = data
        }
        else{
          this.remarkDetail = 'No remarks found!'
        }
        this.$refs.remark.show()
      },

      /**
       * Search the table data with search input
       */
      async ledgerReportData(context) {

        const { sortBy, sortDesc , perPage, currentPage } = context;

        this.currentPage = currentPage;
        this.rowsPerPage = perPage;

        this.isBusy = true

        try{
          const { result } = await this.ledger({
            page: this.currentPage,
            rowsPerPage: this.perPage,
            sortBy,
            descending: sortDesc

          });

          this.totalRows = result.totalCount
          this.orders =  result.data
        }
        catch (e){
          this.orders = []
        }

        this.isBusy = false
        return this.orders;
      },

      async pageChange(page){

        this.currentPage = page
      },

      companyColumn(item){

        if(item.company){
          return item.company.name
        }
        else {

          if(item.type === 'ADMIN'){
            return "ADMIN"
          }
          else{
            return "N/A"
          }
        }
      }
    },
  }
</script>